export const constants = {
    blocks: {
        button: {
            paddingRatio: 0.6,
        },
    },
};
